/** @format */

import React, {useContext} from 'react'

import Modal from '../components/tailwind/Modal'
import {STEPS} from './constants'
import {CheckoutContext} from './CheckoutContext'
import {AccountContext} from '../contexts/AccountContext'

export function BillingModal(props) {
  const {productId, prefix, noMobileScroll} = props
  const {
    currentStep,
    prevStep,
    nextStep,
    currentModal,
    closeModal,
    checkoutData,
    updateCheckoutData
  } = useContext(CheckoutContext)
  const {account} = useContext(AccountContext)

  return (
    <Modal
      title={
        <h4 className={'font-bold text-xl'}>
          {!account && (
            <a
              className="text-gray-600 text-lg cursor-pointer"
              onClick={prevStep}
            >
              &lt; Back &nbsp;&nbsp;&nbsp;
            </a>
          )}
          Billing Address
        </h4>
      }
      isOpen={
        currentModal === prefix + productId && currentStep === STEPS.PERSONAL
      }
      onClose={closeModal}
      className="narrow"
      noMobileScroll={noMobileScroll}
    >
      <form
        onSubmit={nextStep}
        className={'w-full grid grid-cols-1 sm:grid-cols-2 gap-x-4'}
      >
        <div className="sm:col-span-2">
          <label>
            Name:{' '}
            <input
              autoComplete="name"
              name="name"
              autoFocus
              required
              value={checkoutData.name}
              onChange={updateCheckoutData('name')}
            />
          </label>
        </div>
        <div className="sm:col-span-2">
          <label>
            Address:{' '}
            <input
              autoComplete="street-address"
              name="street-address"
              required
              value={checkoutData.address}
              onChange={updateCheckoutData('address')}
            />
          </label>
        </div>
        <div className="sm:col-span-1">
          <label>
            City:{' '}
            <input
              autoComplete="city"
              name="city"
              value={checkoutData.city}
              onChange={updateCheckoutData('city')}
            />
          </label>
        </div>
        <div className="sm:col-span-1">
          <label>
            State/Province:{' '}
            <input
              autoComplete="state"
              name="state"
              value={checkoutData.state}
              onChange={updateCheckoutData('state')}
            />
          </label>
        </div>
        <div className="sm:col-span-2">
          <label>
            Country:{' '}
            <select
              required
              value={checkoutData.country}
              onChange={updateCheckoutData('country')}
            >
              {formspree.billing_countries.map(c => (
                <option value={c.code} key={c.code}>
                  {c.name}
                </option>
              ))}
            </select>
          </label>
        </div>
        <div className="mt-6 right sm:col-span-2">
          <button className="buttonPrimary w-full">Next &gt;</button>
        </div>
      </form>
    </Modal>
  )
}
